/**
 * Pure helper — given the current wizard state, return the step the
 * Previous button should navigate to. Lives in its own module so the
 * unit test can import it without dragging in the React Button
 * component (which transitively imports `@/lib/utils` paths the
 * Jest config doesn't resolve).
 *
 * iter114s.11 — auto-skip-aware:
 *  - Step 6 → 4 (Page 3 → Page 2 / Size+Qty)
 *  - Step 4/5 → 3 normally, → 2 when Material was auto-skipped
 *    (single available material), → 1 when both Material and Format
 *    were auto-skipped (single-format category with single material)
 *  - Step 3 → 2 normally, → 1 when Format was auto-skipped
 *    (single-subcategory category)
 *  - Otherwise → max(1, step − 1)
 */
export const computePrevStep = (
  step,
  { singleMaterial = false, singleFormatCategory = false } = {},
) => {
  if (step === 6) return 4;
  if (step === 4 || step === 5) {
    if (singleMaterial && singleFormatCategory) return 1;
    if (singleMaterial) return 2;
    return 3;
  }
  if (step === 3 && singleFormatCategory) return 1;
  return Math.max(1, step - 1);
};
